export enum DecisionStep {
  EVALUATION,
  GONOGO,
  SUBMISSION,
  RESULTS,
}
